import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyInvoiceRoutingService {
  private URL = environment.api + "api/company-invoice-routing";

  constructor(
    private http: HttpClient
  ) { }

  getAllCompaniesRelated() {
    return this.http.get(this.URL + "/all");
  }

  postRelatedCompaniesInvoice(companyPurchase, companySale, percentage: number) {
    const params = new HttpParams().set('percentage', String(percentage ?? 0));
    return this.http.post(this.URL + "/relation" + "/" + companyPurchase + "/" + companySale, null, { params });
  }

  postRelatedCompaniesInvoiceByRelation(companyPurchase, companySale, relationId, percentage: number) {
    let params = new HttpParams()
      .set('relationId', String(relationId))
      .set('percentage', String(percentage ?? 0));
    return this.http.post(this.URL + "/relation" + "/" + companyPurchase + "/" + companySale, null, { params });
  }

  removeAssociation(relationId) {
    return this.http.delete(this.URL + "/relation/" + relationId);
  }
}

